import { del, get, patch, post, put } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON, valueToDocumentType, } from "../util/amplify-utils";
export default class VelavuAPIBackends {
    //This method returns all of an organization's backends.
    getAllBackends() {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: "/backends",
        })));
    }
    //This method returns a single backend by its unique ID.
    getSpecificBackend(backendID) {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: `/backends/${backendID}`,
        })));
    }
    //This method creates a new backend configuration.
    createNewBackend(params) {
        return normalizePromiseError(operationToJSON(post({
            apiName: API_NAME_VELAVU,
            path: "/backends",
            options: {
                body: valueToDocumentType(params),
            },
        })));
    }
    //This method modifies the name, configuration, or certificates of a backend.
    modifyExistingBackend(backendID, params) {
        return normalizePromiseError(operationToJSON(patch({
            apiName: API_NAME_VELAVU,
            path: `/backends/${backendID}`,
            options: {
                body: valueToDocumentType(params),
            },
        })));
    }
    //This method deletes an existing backend.
    deleteBackend(backendID) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/backends/${backendID}`,
        }).response);
    }
    //This method configures a device to connect to the backend.
    addDevice(backendID, deviceID) {
        return normalizePromiseError(operationToJSON(put({
            apiName: API_NAME_VELAVU,
            path: `/backends/${backendID}/device/${deviceID}`,
        })));
    }
    //This method removes the configuration and disconnects a device from the backend.
    async removeDevice(backendID, deviceID) {
        //AWS Amplify doesn't support a body on DELETE,
        //so we'll use this hack
        const op = del({
            apiName: API_NAME_VELAVU,
            path: `/backends/${backendID}/device/${deviceID}`,
        });
        const response = await normalizePromiseError(op.response);
        const json = await response.body.json();
        return json;
    }
}
//# sourceMappingURL=velavu-api-backends.js.map